import React, { useState, useEffect } from "react";
import Login from "./components/Login";
import Chat from "./components/Chat";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminPanel from "./components/AdminPanel";
import { disconnectSocket } from "./socket";

export default function App() {
  const [session, setSession] = useState(() => {
    const token = localStorage.getItem("token");
    const user  = localStorage.getItem("user");
    return token && user ? { token, user: JSON.parse(user) } : null;
  });

  // view: "login" | "forgot" (irrilevante se loggato) | "admin" (richiede sessione admin)
  const [view, setView] = useState(() =>
    window.location.pathname === "/admin" ? "admin" : "login"
  );

  // Token presente in /reset-password?token=...
  const [resetToken, setResetToken] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return window.location.pathname === "/reset-password" ? params.get("token") : null;
  });

  function handleLogin(token, user) {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setSession({ token, user });
  }

  function handleLogout() {
    disconnectSocket();
    localStorage.clear();
    sessionStorage.clear();
    setSession(null);
    setView("login");
  }

  function exitResetFlow() {
    setResetToken(null);
    window.history.replaceState({}, "", "/");
    setView("login");
  }

  function exitAdminView() {
    window.history.replaceState({}, "", "/");
    setView("login");
  }

  // ── Reset password (accessibile sempre, anche se loggati) ────────────────────
  if (resetToken) {
    return <ResetPassword token={resetToken} onDone={exitResetFlow} />;
  }

  if (session) {
    if (view === "admin") {
      if (session.user.isAdmin) {
        return <AdminPanel onBack={exitAdminView} />;
      }
      return (
        <div className="access-denied">
          <div className="access-denied-box">
            <h2>Accesso negato</h2>
            <p>Non hai i permessi per visualizzare questa pagina.</p>
            <button className="btn-primary" onClick={exitAdminView}>Torna alla chat</button>
          </div>
        </div>
      );
    }
    return (
      <Chat
        session={session}
        onLogout={handleLogout}
        onOpenAdmin={session.user.isAdmin ? () => setView("admin") : undefined}
      />
    );
  }

  if (view === "admin") {
    // /admin senza sessione: torna al login normale
    return <Login onLogin={handleLogin} onForgotPassword={() => setView("forgot")} />;
  }

  if (view === "forgot") {
    return <ForgotPassword onBack={() => setView("login")} />;
  }

  return <Login onLogin={handleLogin} onForgotPassword={() => setView("forgot")} />;
}
